import Vue from "vue"
import Vuex from "vuex"
import Buefy from "buefy"
import Storage from 'vue-ls'
import VuexPersistence from 'vuex-persist'
import VueObserveVisibility from "vue-observe-visibility"
import localforage from 'localforage'
import app from "./modules/app"
import auth from "./modules/auth"
import compose from "./modules/compose"
import images from "./modules/images"

import 'buefy/dist/buefy.css'

Vue.use(Storage)
Vue.use(Vuex)
Vue.use(VueObserveVisibility)
Vue.use(Buefy, {
	defaultIconPack: 'fa',
})

const vuexCompose = new VuexPersistence({
	storage: localforage,
	asyncStorage: true,
	key: 'threadis-main',
	reducer: (state) => ({
		// calls a 'static' method on each of our modules with its own reducer code
		app: app.reducer(state),
		compose: compose.reducer(state),
	})
})

const vuexAuth = new VuexPersistence({
	storage: localforage,
	asyncStorage: true,
	key: 'threadis-auth',
	reducer: (state) => ({
		auth: auth.reducer(state)
	})
})

const vuexImages = new VuexPersistence({
	key: 'threadis-images',
	asyncStorage: true,
	saveState(key, state) {
		return this.restoreState(key).then(val => {
			if (Object.keys(val.images.images).length !== Object.keys(state.images.images).length) {
				localforage.setItem(key, state.images)
			}
		})
	},
	restoreState(key) {
		return localforage.getItem(key).then((val) => {
			return { images: val || { images: {} } }
		})
	}
})


export default new Vuex.Store({
	plugins: [vuexImages.plugin, vuexCompose.plugin, vuexAuth.plugin],
	modules: {
		app,
		auth,
		compose,
		images,
	},
});
